import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ENVIRONMENT } from '../../../../environment/environment';
import { BehaviorSubject, forkJoin, map, Observable, tap } from 'rxjs';
import {
    AaeSubscriptionDetailInterface,
    BillingHistoryInterface,
    SubscriptionDetailInterface,
} from '../../../features/profile/pages/subscription-billing/subscription-billing.model';
import { ApiResponse, Pagination, PaginationFilterInterface } from '../../models/api-response.model';
import {
    RenewType,
    SubscriptionRenewalAddress,
    SubscriptionRenewalDetails,
} from '../../../features/authentication/pages/subscription-renewal/subscription-renewal.model';
import { StripePaymentInterface } from '../../models/user.model';

@Injectable({
    providedIn: 'root',
})
export class SubscriptionService {
    apiRoute = `${ENVIRONMENT.apiDomain}/api/v1/subscription`;
    subscriptionDetailsSubject = new BehaviorSubject<SubscriptionDetailInterface | null>(null);
    subscriptionDetails$ = this.subscriptionDetailsSubject.asObservable();
    aaeDetailsSubject = new BehaviorSubject<AaeSubscriptionDetailInterface | null>(null);
    aaeDetails$ = this.aaeDetailsSubject.asObservable();

    constructor(private httpClient: HttpClient) {}

    public getSubscriptionHistory(
        body: PaginationFilterInterface,
    ): Observable<ApiResponse<Pagination<BillingHistoryInterface[]>>> {
        return this.httpClient.post<ApiResponse<Pagination<BillingHistoryInterface[]>>>(
            `${this.apiRoute}/billing-history`,
            body,
        );
    }

    public fetchAndStoreSubscriptionDetails(): Observable<{
        subscription: ApiResponse<SubscriptionDetailInterface>;
        aae: ApiResponse<AaeSubscriptionDetailInterface>;
    }> {
        return forkJoin({
            subscription: this.httpClient.get<ApiResponse<SubscriptionDetailInterface>>(
                `${this.apiRoute}/taxpod-details`,
            ),
            aae: this.httpClient.get<ApiResponse<AaeSubscriptionDetailInterface>>(`${this.apiRoute}/aae-details`),
        }).pipe(
            tap(({ subscription, aae }) => {
                if (subscription?.result) {
                    this.subscriptionDetailsSubject.next(subscription.result);
                }
                if (aae?.result) {
                    this.aaeDetailsSubject.next(aae.result);
                }
            }),
        );
    }

    public getSubscriptionDetails(id: string): Observable<ApiResponse<SubscriptionRenewalDetails>> {
        return this.httpClient.get<ApiResponse<SubscriptionRenewalDetails>>(`${this.apiRoute}/${id}`);
    }

    public renewSubscription(
        id: string,
        renewType: RenewType,
        agentCode: string,
        address: SubscriptionRenewalAddress,
    ): Observable<StripePaymentInterface> {
        return this.httpClient
            .put<ApiResponse<StripePaymentInterface>>(`${this.apiRoute}/renew/${id}`, {
                renewType,
                agentCode,
                ...address,
            })
            .pipe(
                map((response) => {
                    return (response.result ? response.result : {}) as StripePaymentInterface;
                }),
            );
    }
}
